import React from 'react';
import Image from 'next/image';

const Spinner = '/static/images/spinner.svg';

const AppLoading: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-[#F5F6F7]">
      <Image height={150} width={150} src={Spinner} alt="Loading" />
    </div>
  );
};

export default AppLoading;
